import type { SortInput } from 'components/Table'
import type { ReportSortField } from 'features/yieldbirdWrapperAgent/api/types'

export const DEFAULT_SORT: SortInput<ReportSortField> = {
  by: 'createdAt',
  direction: 'desc',
}
